<template>
  <div>
    <CampaignViewAddBudgetHint
      v-if="searchAdsCampaignHints.addBudgetHint"
      class="campaign-view-hints__item"
    />
    <CampaignViewAddKeywordHint
      v-else-if="searchAdsCampaignHints.addKeywordsHint"
      class="campaign-view-hints__item"
    />
    <CampaignViewCpiLimitHint
      v-if="cpiLimitHint && isCpiLimitEnabled"
      :has-error="hasCpiLimitError"
      :cpi-limit="searchAdsCampaignHints.cpiLimit"
      class="campaign-view-hints__item"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CampaignViewAddKeywordHint from './CampaignViewAddKeywordHint';
import CampaignViewAddBudgetHint from './CampaignViewAddBudgetHint';
import CampaignViewCpiLimitHint from './CampaignViewCpiLimitHint';

import { SEARCH_ADS_CAMPAIGN_HINTS, CAMPAIGN_BIDS } from '@/store/types';
import { IS_SEARCH_ADS_CPI_LIMIT_ENABLED } from '../../Bids/BidsContent/constants';

export default {
  name: 'CampaignViewHints',
  components: {
    CampaignViewAddKeywordHint,
    CampaignViewAddBudgetHint,
    CampaignViewCpiLimitHint,
  },
  computed: {
    ...mapGetters({
      searchAdsCampaignHints: SEARCH_ADS_CAMPAIGN_HINTS,
      bids: CAMPAIGN_BIDS,
    }),
    cpiLimitHint() {
      return this.bids.some(
        bid => bid.priceOffer < this.searchAdsCampaignHints.cpiLimit,
      );
    },
    hasCpiLimitError() {
      return this.bids.every(
        bid => bid.priceOffer < this.searchAdsCampaignHints.cpiLimit,
      );
    },
    isCpiLimitEnabled() {
      return IS_SEARCH_ADS_CPI_LIMIT_ENABLED;
    },
  },
};
</script>

<style lang="scss">
.campaign-view-hints {
  &__item:not(:last-child) {
    margin-bottom: $global-margin;
  }
}
</style>
